module.exports = __webpack_public_path__ + "img/cloud3_1.448708c9.png";